import EnrolmentRecord from './EnrolmentRecord';

export default EnrolmentRecord;
